<template>
  <div>
    <div v-if="unidade && (forceheader || !unidade.fl_timbrado)">
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column" style="height:3cm;">

          <template v-if="unidade_operacao">
            <h4 v-if="parms && parms.nome_contratado" class>{{parms.nome_contratado}}</h4>
            <!-- <h4 v-else class>{{unidade.st_nome_fantasia}}</h4> -->
            <h4 v-else class>{{ unidade_operacao.st_razao_social ? unidade_operacao.st_razao_social : unidade.st_nome_fantasia }}</h4>
            <h5>{{ unidade_operacao.st_nome }}</h5>  

            <template v-if="!block_endereco">
              <div  v-if="unidade_operacao.st_cnpj">
                <div v-if="endereco_exibicao" class="font-weight-light">
                  {{endereco_exibicao.st_logradouro}}, {{endereco_exibicao.st_numero}} - {{endereco_exibicao.st_bairro}} - CEP: {{ this.$util.formatMask((endereco_exibicao.in_cep), 'cep') }}
                  <div v-if="endereco_exibicao.st_complemento">
                    {{ endereco_exibicao.st_complemento }}
                  </div>
                  <div>
                    {{ endereco_exibicao.cidade ? endereco_exibicao.cidade.st_cidade : '' }}
                  </div> 
                  <div>
                    CNPJ: {{ this.$util.formatMask(unidade_operacao.st_cnpj, 'cnpj') }}
                  </div>
                </div>
              </div>
            </template>
          </template>

          <template v-else>
            <h4 v-if="parms && parms.nome_contratado" class>{{parms.nome_contratado}}</h4>
            <h4 v-else class>{{unidade.st_nome_fantasia}}</h4>

            <template v-if="!block_endereco">
              <p v-if="endereco_exibicao" class="font-weight-light">
                {{ endereco_exibicao.st_logradouro}}, {{endereco_exibicao.st_numero}} - Bairro: {{endereco_exibicao.st_bairro}} - CEP: {{ this.$util.formatMask((endereco_exibicao.in_cep), 'cep') }}- 
                {{ endereco_exibicao.cidade ? endereco_exibicao.cidade.st_cidade : '' }}
              </p>
              <div>
                <div v-if="parms && parms.codigo_contratado">
                  {{ parms.codigo_contratado }}
                </div>
                <div  v-else-if="unidade.st_cnpj">
                  CNPJ: {{ this.$util.formatMask(unidade.st_cnpj, 'cnpj') }}
                </div>
                <div v-if="unidade.st_telefone_representante">
                  Tel: {{ this.$util.formatMask(unidade.st_telefone_representante, unidade.st_telefone_representante.length == 10 ? 'tel' : 'cel') }}
                </div>
              </div>
            </template>
          </template>

            <div class="small text-muted">
                Emitido por: {{ $store.state.user.st_login }} em {{ $util.getFormatDate($util.hoje()) }} {{ $util.agora() }}
            </div>
        </div>
        <div>
            <template v-if="!block_logo">
                <img v-if="logo_url" :src="logo_url" height="80mm">
                <img v-else-if="$store.state.logo" :src="$store.state.logo" height="80mm">
            </template>
        </div>
      </div>
    </div>

    

  </div>
</template>

<script>
export default {
  data() {
    return {
      unidade: null
    };
  },

  props: ['forceheader', 'parms', 'id_unidade_operacao', 'logo_url', 'block_endereco', 'endereco', 'block_logo'],

  computed: { 
    endereco_exibicao: function () { 
        if ( this.endereco ) { 
            return this.endereco;
        }
    
        if ( this.unidade_operacao && this.unidade_operacao.endereco ) { 
            return this.unidade_operacao.endereco;
        }

        if ( this.unidade && this.unidade.endereco ) { 
            return this.unidade.endereco;
        }
    
        return null;
    },

    unidade_operacao: function () { 
      if ( this.parms && this.parms.unidade_relatorio ) { 
        return this.$util.unidade_operacao(this.parms.unidade_relatorio);
      }

      if ( !this.id_unidade_operacao ) { 
        if ( this.$store.state.user.id_unidade_operacao ) { 
          return this.$util.unidade_operacao(this.$store.state.user.id_unidade_operacao);    
        } else { 
          return null;
        }
      }
        
      return this.$util.unidade_operacao(this.id_unidade_operacao);
    }
  },

  mounted() {
    this.unidade = this.$store.state.unidade;
  }
};
</script>

<style>
</style>
